import { QPoint } from "../CoreApp/QPoint";

export function XML_GetDashParam(borderThickness) {
  var t = borderThickness + 1.5;
  //	var s = t.toString();
  var s2 = 1.5;

  var p = new QPoint();
  p.InitPoint(t, s2);

  return p;
  //XML_AddPair(s,s2,"dash",drawElement);
}
